<template>
  <div class="live_bg" id="live_bg">
    <div class="live_content">
      <img class="live_content_image" src="../../assets/news/new11_1_1.png" />
      <img class="live_content_image" src="../../assets/news/new11_1_2.png" />
      <img class="live_content_image" src="../../assets/news/new11_1_3.png" />
      <Video class="live_content_video" width="200" height="220" />
      <img
        class="animate-bounce-up"
        v-if="isBounceUp"
        src="../../assets/news/down.png"
      />
    </div>
  </div>
</template>
<script lang="ts">
import Video from "../../components/video/Video.vue";
import { WXApi } from "../../wx/WXApi";
import { Vue, Options } from "vue-class-component";

@Options({
  components: {
    Video
  }
})
export default class LiveVideo extends Vue {
  private isShowShared = false;
  private isShowPoster = false;
  private isBounceUp = true;
  mounted() {
    window.document.title = "CHERRY 2020 全球线上发布会";
    this.defultShare();

    const div = document.getElementById("live_bg") as HTMLDivElement;
    div.addEventListener(
      "scroll",
      () => {
        if (div.scrollTop + window.innerHeight - 20 > window.innerHeight) {
          this.isBounceUp = false;
        } else {
          this.isBounceUp = true;
        }
      },
      false
    );
  }

  defultShare() {
    WXApi.wxShareData(
      this.shareContent(),
      () => {
        console.log();
      },
      () => {
        console.log();
      }
    );
  }
  shareContent() {
    const opstion = {
      title: "[CHERRY∞FUTURE] CHERRY 2020 全球线上发布会 11月1日 20:00",
      link: "https://user.cherry.cn",
      imgUrl: "https://t.irocks.cn/cherry/use/other/11.1_share.png",
      dec: "时隔2年，CHERRY发布会回归。两年间，我们做了什么？"
    };
    return opstion;
  }
  share() {
    WXApi.wxShareData(
      this.shareContent(),
      () => {
        this.isShowShared = true;
      },
      () => {
        this.isShowShared = false;
      }
    );
  }
  poster() {
    this.isShowPoster = true;
  }
  closeShared() {
    this.isShowShared = false;
  }
  closePoster() {
    this.isShowPoster = false;
  }
}
</script>
<style lang="less">
.live_bg {
  background-color: #f6f6f6;
  width: 100%;
  position: fixed;
  margin: 0 auto;
  left: 0px;
  bottom: 0;
  top: 0px;
  overflow-y: scroll;

  .live_content {
    width: 100%;
    background-color: rgb(7, 4, 21);
    .live_content_image {
      margin: 0px 0px 0px 0px;
      padding: 0px 0px 0px 0px;
      // float: left;
      width: 100%;
      height: 100%;
    }
    .live_content_video {
      position: absolute;
      top: 165px;
      left: 10px;
      right: 10px;
      height: 300px;
    }
    .live_content_down {
      position: absolute;
      top: 165px;
      left: 10px;
      right: 10px;
      height: 300px;
    }
    @-webkit-keyframes bounce-up {
      25% {
        -webkit-transform: translateY(10px);
      }
      50%,
      100% {
        -webkit-transform: translateY(0);
      }
      75% {
        -webkit-transform: translateY(-10px);
      }
    }

    @keyframes bounce-up {
      25% {
        transform: translateY(10px);
      }
      50%,
      100% {
        transform: translateY(0);
      }
      75% {
        transform: translateY(-10px);
      }
    }
    .animate-bounce-up {
      position: absolute;
      bottom: 20px;
      right: 48%;
      align-content: center;
      text-align: center;
      align-items: center;
      width: 25px;
      margin: 0px auto;
      -webkit-animation: bounce-up 1.4s linear infinite;
      animation: bounce-up 1.4s linear infinite;
    }
    .live_content_share {
      position: absolute;
      top: 550px;
      right: 10px;
      height: 50px;
    }
    .live_content_generate_poster {
      position: absolute;
      top: 600px;
      right: 10px;
      height: 50px;
    }
  }
}
</style>
